// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"PreviewVideo_videoContainer__1NbgY","mutedVideo":"PreviewVideo_mutedVideo__1_3G2","visible":"PreviewVideo_visible__UcJUy","spin360":"PreviewVideo_spin360__2IPMJ"};